import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import { Card, CardBody, Col } from 'reactstrap';
import renderSelectField from '../../../../shared/components/form/Select';
import setPropsAsInitialValues from '../../../../helpers/setPropsAsInitialValues';
import TextBox from '../../../../shared/components/form/TextBox';
import DatePicker from '../../../../shared/components/form/DatePicker';
import validate from './validate';
import { Calificaciones } from '../../../../constants/enums';

class InscriptionForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    id: PropTypes.number,
    alumnoObj: PropTypes.shape({}),
    examen: PropTypes.shape({}).isRequired,
    alumnos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }

  static defaultProps = {
    id: 0,
    submitting: false,
    alumnoObj: {},
  }

  render() {
    const {
      id,
      submitting,
      handleSubmit,
      onBack,
      examen,
      alumnoObj,
      alumnos,
    } = this.props;

    const { label: nombreAlumno } = alumnoObj;
    const { materia } = examen;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <Form className="form" onSubmit={handleSubmit}>
              <Col md={12} lg={12}>
                <div className="card__title">
                  <h5 className="bold-text">{materia} - Datos de la inscripci&oacute;n o nota de examen</h5>
                </div>
              </Col>
              <Col lx={12} md={12} lg={12}>
                {id <= 0 && (
                  <div className="form__form-group">
                    <span className="form__form-group-label required">Alumno</span>
                    <div className="form__form-group-field">
                      <Field
                        name="alumnoObj"
                        component={renderSelectField}
                        placeholder="Alumno"
                        autoComplete="false"
                        options={alumnos}
                      />
                    </div>
                  </div>
                )}
              </Col>
              <Col lx={12} md={12} lg={12}>
                {id && (
                  <div className="form__form-group">
                    <span className="form__form-group-label required">Alumno</span>
                    <div className="form__form-group-field">
                      <input type="text" value={nombreAlumno} disabled />
                    </div>
                  </div>
                )}
              </Col>
              <Col lx={12} md={6} lg={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Fecha de inscripcion</span>
                  <div className="form__form-group-field">
                    <Field
                      name="fechaInscripcion"
                      component={DatePicker}
                      placeholder="Fecha de inscripcion"
                      autoComplete="false"
                    />
                  </div>
                </div>
              </Col>
              <Col lx={12} md={6} lg={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Porcentaje de asistencia</span>
                  <div className="form__form-group-field">
                    <Field
                      name="porcentajeAsistencia"
                      component={TextBox}
                      type="number"
                      min="0"
                      max="100"
                      step="1"
                      placeholder="Porcentaje de asistencia"
                      autoComplete="false"
                    />
                  </div>
                </div>
              </Col>
              <Col lx={12} md={6} lg={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Porcentaje PP</span>
                  <div className="form__form-group-field">
                    <Field
                      name="porcentajePP"
                      component={TextBox}
                      type="number"
                      min="0"
                      max="100"
                      step="1"
                      placeholder="Porcentaje PP"
                      autoComplete="false"
                    />
                  </div>
                </div>
              </Col>
              <Col lx={12} md={6} lg={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Porcentaje PF</span>
                  <div className="form__form-group-field">
                    <Field
                      name="porcentajePF"
                      component={TextBox}
                      type="number"
                      min="0"
                      max="100"
                      step="1"
                      placeholder="Porcentaje PP"
                      autoComplete="false"
                    />
                  </div>
                </div>
              </Col>
              <Col lx={12} md={6} lg={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Porcentaje PC</span>
                  <div className="form__form-group-field">
                    <Field
                      name="porcentajePC"
                      component={TextBox}
                      type="number"
                      min="0"
                      max="100"
                      step="1"
                      placeholder="Porcentaje PC"
                      autoComplete="false"
                    />
                  </div>
                </div>
              </Col>
              <Col lx={12} md={6} lg={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Calificaci&oacute;n</span>
                  <div className="form__form-group-field">
                    <Field
                      name="calificacionObj"
                      component={renderSelectField}
                      placeholder="Calificaci&oacute;n"
                      autoComplete="false"
                      options={Calificaciones}
                    />

                  </div>
                </div>
              </Col>
            </Form>
            <div className="card__title">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const ReduxInscriptionForm = reduxForm({
  form: 'InscriptionForm',
  validate,
  enableReinitialize: true,
})(InscriptionForm);

export default setPropsAsInitialValues(ReduxInscriptionForm);
